/* global define */

window._define('modules/interventions', ['jquery'], function ($) { 'use strict';
    $(function () {
        $('#checkCreate').change(function() {
            $(this).parents('form').submit();
        });
    });
});
